import { useState, useEffect } from 'react';

const useDashboard = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [branchData, setBranchData] = useState({ branches: [], total_loans: 0, total_amount: 0 });
  const [todaysPayments, setTodaysPayments] = useState({ data: [], total_count: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      setError(null);

      const [statsResponse, summaryResponse, branchResponse, paymentsResponse] = await Promise.all([
        fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/stats`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
          }
        }),
        fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/summary`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
          }
        }),
        fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/loans-by-branch`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
          }
        }),
        fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/todays-payments`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
          }
        })
      ]);

      if (!statsResponse.ok || !summaryResponse.ok || !branchResponse.ok || !paymentsResponse.ok) {
        throw new Error('Error al cargar datos del dashboard');
      }

      const statsResult = await statsResponse.json();
      const summaryResult = await summaryResponse.json();
      const branchResult = await branchResponse.json();
      const paymentsResult = await paymentsResponse.json();

      if (statsResult.success) {
        setDashboardData(statsResult.data);
      }

      if (summaryResult.success) {
        setSummaryData(summaryResult.data);
      }

      if (branchResult.success) {
        setBranchData(branchResult.data);
      }

      if (paymentsResult.success) {
        setTodaysPayments(paymentsResult.data);
      }
    } catch (err) {
      console.error('Error fetching dashboard data:', err);
      setError(err.message);
      
      // Fallback to default data if API fails - ensure exactly 30 data points
      const defaultData = Array(30).fill(0);
      setDashboardData([
        {
          title: 'Préstamos Activos',
          value: '0',
          interval: 'Sin datos',
          trend: 'neutral',
          data: defaultData
        },
        {
          title: 'Monto Total',
          value: '$0',
          interval: 'Sin datos',
          trend: 'neutral',
          data: defaultData
        },
        {
          title: 'Nuevos Préstamos',
          value: '0',
          interval: 'Últimos 30 días',
          trend: 'neutral',
          data: defaultData
        },
        {
          title: 'Monto Nuevo',
          value: '$0',
          interval: 'Últimos 30 días',
          trend: 'neutral',
          data: defaultData
        }
      ]);
      
      setSummaryData({
        active_loans: 0,
        overdue_loans: 0,
        cancelled_loans: 0,
        completed_loans: 0,
        total_products: 0
      });
      
      setBranchData({
        branches: [],
        total_loans: 0,
        total_amount: 0
      });
      
      setTodaysPayments({
        data: [],
        total_count: 0
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const refreshData = () => {
    fetchDashboardData();
  };

  return {
    dashboardData,
    summaryData,
    branchData,
    todaysPayments,
    loading,
    error,
    refreshData
  };
};

export default useDashboard;
